import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import SpaceParticles from "../../components/Particles/SpaceParticles";
import "./Projetos.css";
import { getProjects } from "../../firebase/projectServices";
import { FaExternalLinkAlt } from "react-icons/fa";

const Projetos = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsData = await getProjects();
        setProjects(projectsData);
      } catch (err) {
        console.error("Error fetching projects:", err);
        setError("Falha ao carregar os projetos.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <div className="projetos-page">
      <Navbar activeLink="projetos" />

      <div className="projetos-main">
        <div className="projetos-header">
          <h1 className="projetos-title">Nossos Projetos</h1>
          <p className="projetos-subtitle">
            Conheça os principais projetos que desenvolvemos.
          </p>
        </div>

        {loading ? (
          <div className="projetos-loading">
            <div className="loading-spinner"></div>
            <p>Carregando projetos...</p>
          </div>
        ) : error ? (
          <div className="projetos-error">{error}</div>
        ) : (
          <div className="projetos-grid">
            {projects.map((project, index) => (
              <div
                className="projeto-card"
                key={project.id}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="projeto-image-container">
                  {project.image && (
                    <img
                      src={project.image}
                      alt={project.title}
                      className="projeto-image"
                    />
                  )}
                </div>
                <div className="projeto-content">
                  <h3 className="projeto-title">{project.title}</h3>
                  <p className="projeto-type">{project.type}</p>
                  <p className="projeto-description">{project.description}</p>
                  <div className="projeto-tags">
                    {project.tags?.map((tag, index) => (
                      <span key={index} className="projeto-tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                  {project.demoLink && (
                    <a
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="projeto-link"
                    >
                      Ver Projeto <FaExternalLinkAlt />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
      <SpaceParticles />
    </div>
  );
};

export default Projetos;